<template>
  <div class="relative flex flex-col h-screen bg-grey-100">

    <!-- Top Bar - Back nav, return to MOP -->
    <div id="header-section" class="bg-gray-100 border-b border-2 border-gray-200 text-white flex flex-col items-start z-20">
      <div class="s-top-bar">
        <t-button
          class="text-black lg:ml-10 border-0"
          variant="secondary"
          :class="{ 's-disabled': !exam_type }"
          :disabled="!exam_type" 
          @click="back_or_reset(false)"
        >
          <strong class="underline">Back</strong>
        </t-button>
        <button @click="$root.redirect()" v-html="close" class="s-close-button text-white" />
      </div>
      <!-- Progress bar -->
      <div class="border-b bg-gray-200 w-screen" :style="{ height: '1.5px' }" />
      <div
        class="border-b bg-blue-1000 rounded-full transition animate-pulse"
        :style="{ transition: 'width .8s', width: `${progress}%`, height: '5px' }"
      />
    </div>

    <!-- Body -->
    <div id="body-section" class="flex-1 pt-5 px-5">

      <!-- Set exam type -->
      <div v-if="step_count === 0 || !exam_type">
        <ExamSelector />
      </div>

      <!-- Exam Questions / Steps -->
      <Exam v-else-if="!SHOW_RESULTS" />
       
      <!-- Display results -->
      <div class="flex w-full justify-center items-center">
        <div v-if="SHOW_RESULTS">
          <transition name="old-slide-fade" mode="out-in">
            <ShowResults />
          </transition>
        </div>
      </div>
      
    </div>

    <!-- Footer / Next button -->
    <transition name="basic-fade" mode="out-in">
      <div v-show="exam_type" id="bottom-bar" class="flex justify-center bg-gray-100 border-t border-2 border-gray-200 py-5 text-center text-white is-stuckToBottom">
        <transition name="basic-fade" mode="out-in">
          <t-button v-if="exam_type && !SHOW_RESULTS"
            variant="forward"
            @click="navigate(true)" 
            :disabled="is_next_disabled"
            :class="{ 's-disabled': is_next_disabled }"
          >
            <strong>Next</strong>
          </t-button>
          <!-- <t-button v-else-if="exam_type && SHOW_RESULTS"
            variant="forward"
            @click="GET_LEAD(true)" 
            :disabled="COLLECT_LEAD"
            :class="{ 's-disabled': COLLECT_LEAD }"
          >
            <strong>Get my Report</strong>
          </t-button> -->
        </transition>
      </div>
    </transition>
    

  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ExamSelector from '../components/ExamSelector';
import ShowResults from '../components/ShowResults';

import Exam from '../components/Exam';

export default {
  name: 'Wrapper',
  components: {
    ExamSelector,
    ShowResults,
    Exam
  },
  data() {
    return {
      close: '&#x2715',
    }
  },
  computed: {
    ...mapState({
      step: state => state.step,
      step_count: state => state.exam?.prompts.length,
      SHOW_RESULTS: state => state.SHOW_RESULTS,

      exam_type: state => state.exam_type,
      exam_responses: state => state.exam_responses,
      prompts: state => state.exam?.prompts
    }),
    progress() {
      if (this.exam_type && this.step !== 0 && this.step_count) return (this.step / this.step_count) * 100;
      else return 0
    },
    is_next_disabled() {
      if (this.step > 0) {
        // Check if the current step's prompt has been answered
        const current_prompt = this.prompts[this.step-1].question.prompt;
        const current_response = this.exam_responses[current_prompt];

        switch(typeof current_response) {
          case('array'):
            if (current_response.length === 0) return true;
            else return false;
          case('object'):
            if (!current_response || Object.keys(current_response).length === 0) return true;
            else return false;
          case('string'):
            if (!current_response || current_response === '') return true;
            else return false;
          default:
            return true;
        }
      } else return true;
    }
  },
  methods: {
    ...mapMutations([
      'GET_LEAD',
    ]),
    ...mapActions([
      'navigate',
      'reset_exam',
    ]),
    // Only called when pressing back at step 1
    back_or_reset(forwards) {
      if (this.step === 1) this.reset_exam();
      else this.navigate(forwards);
    },

  }
}
</script>



<style lang="scss" scoped>
#header-section {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  padding-top: 1em;
  // min-height: 73.5px!important;
  // max-height: 73.5px!important;
  .s-top-bar {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0 2em 0.75em 1em;
  }
  .s-close-button {
    background-color: rgba(0,0,0,0.5);
    border-radius: 100%;
    height: 40px;
    width: 40px;
    font-size: 28px;
  }
}

#body-section {
  padding-top: 2rem;
  margin-top: 73.5px!important;
  padding-bottom: calc(95px + 1.5rem)!important;
}
#bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  min-height: 95px!important;
  max-height: 95px!important;
  transition: padding-bottom 0.5s;
}
/* Prevents IOS keyboard bar from hiding text input */
@supports (-webkit-overflow-scrolling: touch) {
  #bottom-bar {
    padding-bottom: 20px;
  }
  #bottom-bar:focus-within {
    padding-bottom: 60px;
    transition: padding-bottom 0.5s;
  }
}

</style>
